import { IDataState, IChangeState } from "../state.types";

export const setCedulaType = (state: IDataState, payload: IChangeState) => {
  return { ...state, typeCedula: payload.newCedula } as IDataState;
};

export const setStatusServer = (state: IDataState, payload: IChangeState) => {
  return { ...state, getStatusServer: payload.newStatusServer } as IDataState;
};
